export default "__VITE_ASSET__CvKvlRqk__"